<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center pl-1 pr-1">
      <b-col md="8">
        <b-card-group>
          <b-card class="no-margin">
            <b-col style="height: 90vh; padding: 0; margin-bottom: 0" id="map_container"
                   ref="map_container">
            </b-col>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col>
        <b-card-group>
          <b-card class="no-margin">
            <b-table sticky-header striped hover
                     ref="tour_objects_table"
                     :items="streets"
                     :fields="fields"
                     selectable
                     select-mode="single"
                     selectedVariant="primary"
                     style="max-height: 90vh; min-height: 90vh; margin-bottom: 0px"
            >

              <template v-slot:cell(controls)="data">
                <duplicate-icon
                    title=""
                    v-tooltip="'Duplizieren'"
                    class="icon-1_5x" style="color: #016d03; cursor: pointer" :size="72" @click.stop=""></duplicate-icon>
                <delete-icon
                    title=""
                    v-tooltip="'Löschen'"
                    class="icon-1_5x" style="color: #b60110; cursor: pointer" :size="72" @click.stop=""></delete-icon>
              </template>
            </b-table>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  decryptAES,
  encryptAES,
} from "@/shared/crypto";
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import AccountBox from 'vue-material-design-icons/AccountBox.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import StylesControl from 'mapbox-gl-controls/lib/styles';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {styles} from '@/shared/draw_style';
import {v4} from "uuid";


export default {
  name: "StreetsTest",
  components: {
  },
  computed: {
  },
  data: () => {
    return {
      loader: undefined,
      streets: [],
      fields: [
        {key: 'name', label: "Name", sortable: true},
        {key: 'type', label: "Typ", sortable: true},
        {key: 'controls', label: ""},
      ],

    }
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/bd/overpass_streets'
    ).then(this.responseOkFetch, this.responseError)
  },
  methods: {

    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }

    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    async responseOkFetch(response) {
      if (response.status === 200) {
        this.sources = response.body.sources;
        this.streets = response.body.streets;
        this.hideLoader();
        this.showMap();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    showMap() {
      setTimeout(() => {
        this.isInitial = true;
        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
        this.map = new mapboxgl.Map({
          container: 'map_container',
          style: 'mapbox://styles/mapbox/outdoors-v11',
          center: [11.889004, 48.073820],
          zoom: 12,
          minZoom: 5,
          maxZoom: 19,
          maxPitch: 0,
        });
        this.draw = new MapboxDraw({
          displayControlsDefault: false,
          controls: {
            point: true,
            line_string: false,
            polygon: false,
            trash: true,
          },
          styles: styles
        });
        this.map.addControl(new StylesControl({
          styles: [
            {
              label: 'Normal',
              styleName: 'Mapbox Streets',
              styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
            }, {
              label: 'Satellit',
              styleName: 'Satellite',
              styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
            },
          ],
          onChange: () => this.map.once("style.load", () => {
            this.calculateLayers();
          }),
        }), 'top-left');
        this.map.addControl(new ZoomControl(), 'bottom-right');
        const languageControl = new LanguageControl({
          language: 'de',
        });
        this.map.addControl(languageControl);
        this.geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          placeholder: "Suchen",
          zoom: 19,
          language: 'de-DE',
          countries: 'de',
          marker: false,
          flyTo: true,
        });
        this.geocoder.on("result", (res) => {

        });
        this.map.addControl(
            this.geocoder
        );
        //this.map.on('click', this.onMapClick);
        this.map.once('load', this.onMapLoad)
      });
    },
    onMapLoad() {
      setTimeout(() => {
        this.map.resize();
        this.map.addControl(this.draw, 'top-left');
        this.map.on('draw.modechange', this.onModeChange);
        this.map.on('draw.create', this.onFeatureCreate);
        this.map.on('draw.delete', this.onFeatureDelete);
        this.map.on('draw.update', this.onFeatureMove);
        this.isInitial = false;
        this.calculateLayers();
      });
    },
    onModeChange(mode) {
      if (mode.mode.startsWith("draw_") && this.draw.getAll().features.length > 1) {
        this.draw.changeMode("simple_select", {
          featureIds: [this.draw.getAll().features[0].id]
        });
        this.$bvToast.toast("Bitte löschen Sie zuerst Ihre bisherige Selektion um neu beginnen zu können.", {
          title: 'Achtung',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
          variant: 'warning',
          solid: true
        })
      }
    },
    onFeatureCreate({features}) {
      if (!this.currentObject) {
        throw new Error('Can not create a feature without a current object.');
      }
      let coords = features[0].geometry.coordinates;
      this.currentObject.lat = coords[1];
      this.currentObject.lon = coords[0];
    },
    onFeatureDelete() {
      if (!this.currentObject) {
        throw new Error('Can not delete a feature without a current object.');
      }
      this.currentObject.lat = 0.0;
      this.currentObject.lon = 0.0;
    },
    onFeatureMove({features}) {
      if (!this.currentObject) {
        throw new Error('Can not update a feature without a current object.');
      }
      let coords = features[0].geometry.coordinates;
      this.currentObject.lat = coords[1];
      this.currentObject.lon = coords[0];
    },
    removeMapSources() {
      if (this.markers && this.markers.length) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].remove()
        }
      }
      this.markers = [];
      this.removeLayer('maine');
      this.removeLayer('outline');
      this.removeSource('poly');
      this.removeLayer('route');
      this.removeSource('linestring');
      this.removeLayer('point');
      this.removeSource('pointcoord');
      this.removeLayer('selectedPoly');
      this.removeLayer('selectedOutline');
      this.removeSource('selectedPoly');
      this.removeLayer('selectedLine');
      this.removeSource('selectedLine');
      this.removeLayer('selectedPoint');
      this.removeSource('selectedPoint');
    },
    removeLayer(id) {
      if (this.map.getLayer(id)) {
        this.map.removeLayer(id);
      }
    },
    removeSource(id) {
      if (this.map.getSource(id)) {
        this.map.removeSource(id);
      }
    },
    moveDrawLayer() {
      var layers = this.map.getStyle().layers;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].source && layers[i].source.includes("mapbox-gl-draw")) {
          this.map.moveLayer(layers[i].id);
        }
      }
    },
    doesStreetExist(name) {
      if (name === 'unclassified') {
        return false;
      }
      for (let i = 0; i < this.streets.length; i++) {
        if (this.streets[i].name === name) {
          return true;
        }
      }
      return false;
    },
    calculateLayers() {

      // make unique
      for (const key in this.sources) {
        this.map.addSource(key, this.sources[key]);
        this.map.addLayer({
          'id': key,
          'type': 'line',
          'source': key,
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': this.doesStreetExist(key) ? 'rgba(5,239,68,0.8)' : 'rgba(62,149,243,0.8)',
            'line-width': 5
          }
        });
      }
      this.map.on('click', 'unclassified', (e) => {
        console.log(e.features)
      });

      // Change the cursor to a pointer when
      // the mouse is over the states layer.
      this.map.on('mouseenter', 'unclassified', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });

      // Change the cursor back to a pointer
      // when it leaves the states layer.
      this.map.on('mouseleave', 'unclassified', () => {
        this.map.getCanvas().style.cursor = '';
      });
    },
  }
}
</script>

<style scoped>
::v-deep .card-body {
  padding: 0 !important;
}
</style>
